import { createSlice } from "@reduxjs/toolkit";

export const objetivosSlices = createSlice({
  name: "objetivos",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = objetivosSlices.actions;

export default objetivosSlices.reducer;
